import LZString from "lz-string";
import { SaveManager, SAVE_KEY, type GameSave } from "./SaveManager";

/**
 * Código de progreso portable: permite continuar la partida en OTRO ordenador
 * (o cuando el equipo del centro borra los datos al cerrar sesión). Todo el
 * guardado se comprime a una cadena que el alumno copia/guarda y pega para
 * seguir. No hay servidor: sigue siendo 100% en el navegador (privacidad
 * intacta). Formato: prefijo "EPI1-" + guardado comprimido (lz-string base64).
 */

const PREFIX = "EPI1-";

/** Genera el código con el progreso actual (guardado completo). */
export function exportCode(): string {
  const data = SaveManager.get();
  const json = JSON.stringify(data);
  return PREFIX + LZString.compressToBase64(json);
}

/** Restaura un código: escribe el guardado y devuelve si fue válido.
 *  Tras un import correcto conviene recargar la página para rehidratar todo. */
export function importCode(code: string): boolean {
  try {
    const trimmed = (code || "").trim();
    if (!trimmed) return false;
    const body = trimmed.startsWith(PREFIX) ? trimmed.slice(PREFIX.length) : trimmed;
    const json = LZString.decompressFromBase64(body);
    if (!json) return false;
    const data = JSON.parse(json) as Partial<GameSave>;
    if (!data || typeof data !== "object" || typeof data.version !== "number") return false;
    // se escribe directamente en localStorage; una recarga rehidrata el estado
    localStorage.setItem(SAVE_KEY, JSON.stringify(data));
    return true;
  } catch {
    return false;
  }
}

/** ¿Hay algún progreso que merezca la pena guardar? (algún capítulo tocado). */
export function hasSaveableProgress(): boolean {
  try {
    const m = SaveManager.get().missions as { progress?: Record<string, unknown> } | undefined;
    return !!m?.progress && Object.keys(m.progress).length > 0;
  } catch {
    return false;
  }
}

/** Descarga el código como archivo de texto (alternativa al copiar/pegar). */
export function downloadSave(): void {
  const code = exportCode();
  const blob = new Blob([code], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `aventuras-epi-progreso-${new Date().toISOString().slice(0, 10)}.txt`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
